import { jsx as r } from "react/jsx-runtime";
import "../../utils/sectionPreview.js";
import "react";
import p from "clsx";
import "../Button/Button.js";
import "../../_chunks/RadioRatingStarButton.CgEHfOo2.js";
import "next/link";
import "js-cookie";
import "../Combobox/Combobox.js";
import "../Datepicker/Datepicker.js";
import { Typography as n } from "../Typography/Typography.js";
import "@portabletext/react";
import "../Grid/Col/Col.js";
import "react-is";
import "../IconButton/IconButton.js";
import "next/image";
import "next/head";
import "../Input/Input.js";
import "@hookform/error-message";
import "../Modal/constants.js";
import "../Modal/ModalContent.js";
import "../Modal/ModalFooter.js";
import "../Modal/ModalHeader.js";
import "../Modal/ModalContext.js";
import "../RadioButton/RadioButton.js";
import "../Switch/Switch.js";
import '../../_assets/Chip.DdMBi1eJ.css';const s = "_root_1bu1o_44", e = "_base_1bu1o_50", m = "_success_1bu1o_54", c = "_error_1bu1o_58", _ = "_outline_1bu1o_62", u = "_important_1bu1o_67", t = {
  root: s,
  base: e,
  success: m,
  error: c,
  outline: _,
  important: u,
  "slide-in-out": "_slide-in-out_1bu1o_1",
  "fade-in-out": "_fade-in-out_1bu1o_1"
}, l = {
  base: { variant: "portalCaption", size: "2", color: "brand-dark" },
  success: { variant: "portalCaption", size: "2", color: "brand-dark" },
  error: { variant: "portalCaption", size: "2", color: "brand-dark" },
  outline: { variant: "portalCaption", size: "2", color: "brand-dark" },
  important: { variant: "captionMono", size: "2", color: "brand-white" }
}, I = ({ label: i, variant: o = "base", className: a }) => /* @__PURE__ */ r("div", { className: p(t.root, t[o], a), children: /* @__PURE__ */ r(n, { ...l[o], noPadding: !0, children: i }) });
export {
  I as Chip
};
